/* unplugin-vue-components disabled */import script from "./paper-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./paper-modal.vue?vue&type=script&setup=true&lang=js"

import "./paper-modal.vue?vue&type=style&index=0&id=00f861a0&lang=scss"

const __exports__ = script;

export default __exports__